import style from "./style.module.scss";
import mobile from "./mobile.png";
import { useState } from "react";
import { CheckUser } from "../../../../../Web/View/Auth/Components/Services";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

const LoginRegister = ({ step, setStep, isWebview, setShowModal }) => {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    const [mobileNumber, setmobileNumber] = useState("");

    const NextToStep = () => {
        if (mobileNumber.length > 0) {
            CheckUser(mobileNumber).then(result => {
                if (result && result.user) {
                    dispatch({
                        type: "SET",
                        payload: { mobile: mobileNumber }
                    })
                    if (isWebview) {
                        navigate("/", {
                            state: { mobile: mobileNumber },
                        });
                    }
                    setStep("step5")
                }
                else {
                    dispatch({
                        type: "SET",
                        payload: { mobile: mobileNumber }
                    })
                    if (isWebview) {
                        navigate("/", {
                            state: { mobile: mobileNumber },
                        });
                    }
                    setStep("step4")
                }
            })
        }
        else {
            toast.error("شماره اشتباه است.")
        }
    }
    return (
        <>
            <section>
                <div>
                    <h3 className={style.titelTextLogin}>ورود / ثبت نام</h3>
                </div>
                <div className="d-flex justify-content-center">
                    <div className="">
                        <p className={style.warnLogin}>لطفا برای ادامه شماره موبایل خود را وارد کنید.</p>
                        <div className={style.parentInputLogin}>
                            <input className={style.inputLogin} onChange={e => setmobileNumber(e.target.value)} value={mobileNumber} type="number" name="number" placeholder="شماره موبایل" id="number" />
                            <img src={mobile} className={style.mobileIconLogin} alt="icon" />
                        </div>
                        <button onClick={() => NextToStep()} className={style.btnLogin}>ورود یا ثبت نام</button>
                        <p className={style.endText}>
                            <span onClick={e => setShowModal(true)} className="textMain diflex mx-1">قوانین سایت</span>
                            و
                            <span onClick={e => setShowModal(true)} className="textMain diflex mx-1">حریم خصوصی</span>
                            را می پذیرم
                        </p>
                    </div>
                </div>
            </section>
            {/* {showModal&&} */}
            <div></div>
        </>
    );
};

export default LoginRegister;